import Vue from 'vue'
import storage from 'good-storage'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '@/components/login'
import margin from '@/components/margin'
import cardList from '@/components/cardList'
import jiayou_card from '@/components/jiayou_card'
import jiayou_operation from '@/components/jiayou_operation'
import driver_list from '@/components/driver_list'
import driver_operation from '@/components/driver_operation'
import upd_password from '@/components/upd_password'
import distribution_record from '@/components/distribution_record'
import top_up from '@/components/top_up'
import ComeOn_record from '@/components/ComeOn_record'
import ComeOn_record_detail from '@/components/ComeOn_record_detail'
import reconciliation from '@/components/reconciliation'
import chooseTIme from '@/components/chooseTIme'
import setShare from '@/components/set_share'
import cardComeon_record from '../components/cardComeon_record.vue'
import updCard_info from '../components/updCard_info.vue'
import wode from '../components/wode.vue'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/margin',
      name: 'margin',
      component: margin
    },
    {
      path: '/cardList',
      name: 'cardList',
      component: cardList
    },
    {
      path: '/jiayou_card',
      name: 'jiayou_card',
      component: jiayou_card
    },
    {
      path: '/jiayou_operation',
      name: 'jiayou_operation',
      component: jiayou_operation
    },
    {
      path: '/driver_list',
      name: 'driver_list',
      component: driver_list
    },
    {
      path: '/driver_operation',
      name: 'driver_operation',
      component: driver_operation
    }
    ,
    {
      path: '/upd_password',
      name: 'upd_password',
      component: upd_password
    }
    ,
    {
      path: '/distribution_record',
      name: 'distribution_record',
      component: distribution_record
    },
    {
      path: '/top_up',
      name: 'top_up',
      component: top_up
    },
    {
      path: '/ComeOn_record',
      name: 'ComeOn_record',
      component: ComeOn_record
    },
    {
      path: '/ComeOn_record_detail',
      name: 'ComeOn_record_detail',
      component: ComeOn_record_detail
    },
    {
      path:'/reconciliation',
      name:'reconciliation',
      component:reconciliation
    },
    {
      path:'/chooseTIme',
      name:'chooseTIme',
      component:chooseTIme
    },{
      path:'/setShare',
      name:'setShare',
      component:setShare
    },{
      path:'/cardComeon_record',
      name:'cardComeon_record',
      component:cardComeon_record
    },{
      path:'/updCard_info',
      name:'updCard_info',
      component:updCard_info
    },{
      path:'/wode',
      name:'wode',
      component:wode
    }
  
  ]
})
router.beforeEach((to,from,next)=>{
  let isLogin = storage.get('token');
    if (isLogin) {
        //如果用户信息存在则往下执行。
        next()
    } else {
        //如果用户token不存在则跳转到login页面
        if (to.path === '/') {
            next()
        } else {
          alert('登录失效或过期，请重新登录')
            next('/')
        }
    }

})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js